export default __webpack_public_path__ + "static/media/Customization.2a5edb0a.svg";